export default {"src":"/_next/static/media/logo.75912804.svg","height":42,"width":41,"blurWidth":0,"blurHeight":0};